// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aCa-H","tabsBox":"styles_tabsBox__37rUQ","createButton":"styles_createButton__k97vO"};